<div *ngIf="initialized" class="w3-container w3-margin-top" [class]="router.back ? 'w3-animate-left' : 'w3-animate-right'">
  <div class="w3-margin" *ngIf="!message.error">
    <div class="w3-container">
      <img id="login_logo" class="w3-image loading" src="assets/images/icon_omnicard.png" />
    </div>
  </div>
</div>
